import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="mb-6">
              <img 
                src="https://static.readdy.ai/image/4f005a6d9d587cd5cd5ab19a1efc7d16/e6bc1268a18391062efc3c74a05c24f8.png" 
                alt="El Paso Cash Home Buyers" 
                className="w-full max-w-[350px] h-auto"
              />
            </div>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=61587151889957" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-gray-800 hover:bg-teal-600 rounded-lg flex items-center justify-center transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* About Us */}
          <div>
            <h4 className="text-lg font-bold mb-6">About Us</h4>
            <p className="text-gray-400 leading-relaxed">
              We are TREX RE LLC! A real estate investment company that buys and rents real estate in El Paso Texas. El Paso's trusted cash home buyers since 2016. We buy houses in any condition, helping homeowners sell fast without the hassle. So call us to sell your real estate today!
            </p>
          </div>

          {/* We Buy Property */}
          <div>
            <h3 className="text-lg font-bold mb-6">We Buy Property</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/avoid-foreclosure" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Foreclosure Help
                </Link>
              </li>
              <li>
                <Link to="/inherited-homes" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Inherited Homes
                </Link>
              </li>
              <li>
                <Link to="/rental-property" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Rental Properties
                </Link>
              </li>
              <li>
                <Link to="/sell-apartments" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Apartments
                </Link>
              </li>
              <li>
                <Link to="/title-issues" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Title Issues
                </Link>
              </li>
              <li>
                <Link to="/land-buyers" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  El Paso Land Buyers
                </Link>
              </li>
              <li>
                <Link to="/sell-distressed-property" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  Distressed Properties
                </Link>
              </li>
            </ul>
          </div>

          {/* TREX RE LLC */}
          <div>
            <h3 className="text-lg font-bold mb-6">TREX RE LLC</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-teal-400 text-lg mt-1"></i>
                <div className="text-gray-400">
                  3016 Gull Lake Pl<br />
                  El Paso, TX 79936
                </div>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-phone-line text-teal-400 text-lg mt-1"></i>
                <a href="tel:+1-915-206-5814" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  (915) 206-5814
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-teal-400 text-lg mt-1"></i>
                <a href="mailto:ElPaso@trexrealestate.com" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  ElPaso@trexrealestate.com
                </a>
              </li>
              <li className="pt-2">
                <Link to="/" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  We Buy Real Estate
                </Link>
              </li>
              <li>
                <Link to="/rental-property/rent-houses-apartments" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  We Rent Houses & Apartments
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm">
              © {currentYear} El Paso Cash Home Buyers. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                Privacy Policy
              </Link>
              <Link to="/terms-of-service" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                Terms of Service
              </Link>
              <button
                onClick={() => navigate('/')}
                className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer"
              >
                Real Estate Investors El Paso
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
